export const queryKeys = {
  base: ['calls'] as const,
  outboundNumbers: (tenantId: string) => [...queryKeys.base, 'outbound-voice-numbers', tenantId],
  getNumbersBySipProfileId: (sipProfileId: string) => [...queryKeys.base, 'outbound-caller-numbers', sipProfileId],
};
